import React from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import InstagramSvg from 'pubweb-smokey/dist/images/svg/iconography-social/instagram.svg';
import { getContentfulApiVersion } from '@utils/config';

export const Card = ({ item, index, className, isMobile }) =>
  item ? (
    <li className={className}>
      <a href={item.imageUrl?.trim()} target="_blank" rel="noopener noreferrer">
        {item?.imageAsset?.fields && (
          <Image
            src={`${
              getContentfulApiVersion() == 'v2'
                ? item.collectionImage?.file.url
                : item.collectionImage?.fields?.file.url
            }?q=85&w=450&fm=webp`}
            alt={
              getContentfulApiVersion() == 'v2'
                ? item.collectionImage?.title
                : item.collectionImage?.fields?.title
            }
            fill
          />
        )}
        {item?.imageAsset?.fields &&
          ((isMobile && index === 3) || (!isMobile && index === 4)) && (
            <div className="instagram-tile">
              <InstagramSvg viewBox="0 0 16 16" />
            </div>
          )}
      </a>
    </li>
  ) : null;

Card.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};

export const CollectionCard = ({ item }) =>
  item ? (
    <li className="image-list-item">
      <a href={item.slug?.trim()}>
        <div className="image-list-item-image">
          <Image
            src={`${item.collectionImage?.file.url}?q=85&w=450&fm=webp`}
            alt={item.collectionImage?.title}
            width={450}
            height={140}
          />
        </div>
        <h5>{item.collectionTitle}</h5>
      </a>
    </li>
  ) : null;

CollectionCard.propTypes = {
  item: PropTypes.object,
};
